import React, { useEffect, useState } from "react";
import { api, i18n } from "@/lib/api";

export default function SyllabusPanel({ language, items, onChanged }) {
  const t = i18n[language];
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ course_title: "", semester_label: "", syllabus_text: "" });
  const [busy, setBusy] = useState(false);

  const reset = () => {
    setEditing(null);
    setForm({ course_title: "", semester_label: "", syllabus_text: "" });
  };

  const save = async () => {
    if (!form.course_title.trim()) return;
    setBusy(true);
    try {
      await api.saveSyllabus(editing ? { ...form, syllabus_id: editing } : form);
      onChanged?.();
      reset();
    } finally {
      setBusy(false);
    }
  };

  const startEdit = (item) => {
    setEditing(item.syllabus_id);
    setForm({
      course_title: item.course_title || "",
      semester_label: item.semester_label || "",
      syllabus_text: item.syllabus_text || "",
    });
  };

  return (
    <div data-testid="syllabus-panel">
      <div className="h-eyebrow">{t.syllabus}</div>
      <h2 className="h-display" style={{ fontSize: "1.3rem", margin: "0.35rem 0 1rem" }}>
        {language === "es" ? "Programas de Curso" : "Course Syllabi"}
      </h2>

      {items.length > 0 && (
        <div style={{ marginBottom: "1.25rem" }}>
          {items.map((s) => (
            <div key={s.syllabus_id} style={{ padding: "0.6rem 0", borderBottom: "1px solid var(--line)", display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div>
                <div>{s.course_title}</div>
                <div className="kbd">{s.semester_label}</div>
              </div>
              <button data-testid={`syllabus-edit-${s.syllabus_id}`} className="btn-link" onClick={() => startEdit(s)}>
                {language === "es" ? "Editar" : "Edit"}
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="line" />
      <div className="h-eyebrow">{editing ? (language === "es" ? "Editar" : "Edit") : t.addSyllabus}</div>

      <div className="input-line focus-line" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <label className="h-eyebrow" htmlFor="syllabus-title">{t.syllabusTitle}</label>
        <input id="syllabus-title" data-testid="syllabus-title-input" value={form.course_title} onChange={(e) => setForm({ ...form, course_title: e.target.value })} />
      </div>

      <div className="input-line focus-line" style={{ marginBottom: "1rem" }}>
        <label className="h-eyebrow" htmlFor="syllabus-semester">{t.syllabusSemester}</label>
        <input id="syllabus-semester" data-testid="syllabus-semester-input" value={form.semester_label} onChange={(e) => setForm({ ...form, semester_label: e.target.value })} placeholder="Fall 2026" />
      </div>

      <div className="input-line focus-line" style={{ marginBottom: "1.5rem" }}>
        <label className="h-eyebrow" htmlFor="syllabus-text">{t.syllabusText}</label>
        <textarea id="syllabus-text" data-testid="syllabus-text-input" rows={8} value={form.syllabus_text} onChange={(e) => setForm({ ...form, syllabus_text: e.target.value })} />
      </div>

      <div style={{ display: "flex", gap: "1rem" }}>
        <button data-testid="syllabus-save" className="btn-primary" onClick={save} disabled={busy}>
          {busy ? "..." : t.save}
        </button>
        {editing && (
          <button className="btn-ghost" onClick={reset}>
            {language === "es" ? "Cancelar" : "Cancel"}
          </button>
        )}
      </div>
    </div>
  );
}
